<template>
  <div class="content">
    <div class="text-sm my-8" v-html="compiledMarkdown"></div>
    <framed-image :images="images" :autoplay="true" />
    <router-link class="border border-jpink mt-8 block py-2 px-4 mx-4 text-jpink hover:bg-jpink hover:text-white" :to="{name: 'basket'}">Order now</router-link>

  </div>
</template>

<script>
import FramedImage from '../components/FramedImage'
import marked from 'marked';
import { map } from 'lodash'
export default {
  components: {
    FramedImage
  },
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.home_content)
    },
    images() {
      return map(this.$root.$data.images.home_images, 'image')
    }
  }
}
</script>
